<template>
    <div>
        <el-dialog class="productTypeDialog" :append-to-body="true" title="提示" custom-class="customProduct"
            :visible.sync="payShow">
            <div class="dialog-top">
                <span>支付方式</span>
            </div>
            <div class="product-checkBox"
                style="padding-right: 10px;display: flex;flex-direction: column;justify-content: center;">
                <el-radio-group v-model=checkPay @change="checkPayChange">
                    <el-radio :label="1" class="alipay">
                        <img src="@/assets/png/aliPay.png" />
                    </el-radio>
                    <el-radio :label="2" class="wechat">
                        <img src="@/assets/png/wechatPay.png" />
                    </el-radio>
                    <el-radio :label="3" class="wallet">
                        <img src="@/assets/png/qb1.png" />
                    </el-radio>
                </el-radio-group>
            </div>
            <el-divider v-if="checkPay > 0" style="margin-top: -2px;"></el-divider>
            <div class="Total-Price amountDetails" v-if="checkPay > 0">
                <div style="display: flex;align-items: center;flex-direction: column">
                    <span style="width: 100%;padding-bottom: 10px;">您选择的支付方式为{{ checkName[this.checkPay].name }}:</span>
                    <p class="_p">
                        <span class="_span">实付金额：</span>
                        <span style="color: #DD5827;font-size: 0.16rem">¥ {{ dataMap.totalPrice }}</span>
                    </p>
                    <p class="_p" v-if="dataMap.actualPrice && dataMap.actualPrice > 0">
                        <span class="_span">应付金额：</span>
                        <span style="color: #DD5827;font-size: 0.16rem">¥ {{ dataMap.actualPrice }}</span>
                    </p>
                    <template v-if="dataMap.stateMaps">
                        <p class="_p"
                            v-for="(item, index) in dataMap.stateMaps.filter(x => x.inventoryExpiredTotalPrice > 0)"
                            :key="index">
                            <span class="_span">{{ item.stateName }}库存不足：</span>
                            <span style="color: #DD5827;font-size: 0.16rem">-¥ {{ item.inventoryExpiredTotalPrice }}</span>
                        </p>
                    </template>
                </div>
            </div>
            <!--        <div class="amountDetails" v-if="checkPay > 0">-->
            <!--            <p>您选择的支付方式为：<span style="text-decoration: underline;text-underline-offset: 2px">{{ checkName[checkPay].name }}</span></p>-->
            <!--            <p>实付款金额为：<span style="color: red;font-weight: 700">¥1000</span></p>-->
            <!--            <p>优惠金额为：<span style="color: red;font-weight: 700">¥100</span></p>-->
            <!--            <p>因库存原因扣减金额为：<span style="color: red;font-weight: 700">¥100</span></p>-->
            <!--        </div>-->

            <div v-if="checkPay === 3" style="position: relative;top: -11px;">
                <el-divider style="margin-top: -15px;"></el-divider>
                <el-form v-loading="isLoading" :model="ruleForm" ref="ruleForm" label-width="100px"
                    class="mobileVerification">
<!--                    <div v-if="walletObj.scheduleFlag || walletObj.scheduleFlag == null">-->
<!--                        <el-form-item label="手机号码为:" prop="name">-->
<!--                            <span style="position: relative;left: -20px">{{ userInfor.phoneNumber }}</span>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="验证码校验:" prop="name" class="macontent">-->
<!--                            <el-input style="margin-right: 5px" placeholder="验证码" v-model="ruleForm.code"-->
<!--                                class="input-with-select"></el-input>-->
<!--                            <span class="verify" v-if="count < 1 || count === ''" @click="verify">获取验证码</span>-->
<!--                            <span class="verify" v-else>({{ count }}s)后重新获取</span>-->
<!--                        </el-form-item>-->
<!--                    </div>-->
                    <div v-if="JSON.walletObj !== '{}' && !walletFlag(walletObj).auditingFlag">
                        <div class="lineBox">
                            <p class="lineBoxP1">专项款余额：</p>
                            <p style="color: #DD5827;font-size: 0.16rem">¥ {{ walletObj.balanceOfSpecialFunds }}</p>
                        </div>
                        <div class="lineBox">
                            <p class="lineBoxP1">钱包余额：</p>
                            <p style="color: #DD5827;font-size: 0.16rem">{{ walletObj.walletBalance }}</p>
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="opButton" v-if="walletFlag(walletObj).auditingFlag || checkPay != 3">
                <el-button @click="payShow = false">取消</el-button>
                <el-button  style="background-color: var(--navberColor);color: white" type="primary"  @click="confirmPay">确定</el-button>
            </div>
            <div v-if="checkPay == 3 && !walletFlag(walletObj).auditingFlag" class="opButton">
                <el-button v-if="walletObj.schedule == 0" size="mini" type="primary"
                    @click="handlerWalletClick(walletObj.applyConfigId)">{{
                        walletFlag(walletObj).auditingText }}</el-button>
                <el-tag v-if="walletObj.schedule == 1" type="success">{{ walletFlag(walletObj).auditingText }}</el-tag>
                <el-tag v-if="walletObj.schedule == 3" type="warning">{{ walletFlag(walletObj).auditingText }}</el-tag>
                <div class="lineBox" v-if="walletObj.schedule == 3">
                    <p class="lineBoxP1">驳回理由：</p>
                    <p style="color:#000 ;font-size: 0.16rem">{{ walletObj.reasonForRejection }}</p>
                </div>
            </div>
        </el-dialog>
        <payCpmponent :routeData="routeData" @updatePrice="updatePrice" ref="payCpmponent" :orderMainId="orderMainId"
            :payPrice="Number(payMoney)" :types="checkPay === 1 ? '支付宝' : '微信'"></payCpmponent>
        <officialAccountVue @closePopup="closePopup" ref="officialAccountVue"></officialAccountVue>
    </div>
</template>

<script>
import CountDown from '@/assets/utils/countDown'
import Api from "@/components/Api";
import { mapState } from "vuex";
import PayApi from "@/components/Api/pay";
import OrderApi from "@/components/Api/order";
import { Loading } from "@/components/Loding/Loading";
import payCpmponent from '../../views/mechanism/components/institutionalWalletChild/child/payCpmponent.vue';
import officialAccountVue from '../officialAccount/officialAccount.vue';
import ApplyApi from "@/components/Api/apply";
export default {
    name: "Pay",
    data() {
        return {
            ruleForm: {
                code: '',
                bizId: ''
            },
            isLoading: false,
            count: '',
            payShow: false,
            walletObj: {},
            // -1 未选择支付方式 1 支付宝支付 2 微信支付 3 360币支付
            checkPay: 0,
            checkName: {
                1: {
                    name: '支付宝支付'
                },
                2: {
                    name: '微信支付'
                },
                3: {
                    name: '钱包支付'
                }
            }
        }
    },
    components: { payCpmponent, officialAccountVue },
    mixins: [Loading],
    props: {
        dataMap: {
            type: Object,
            default: () => {
                return {
                    totalPrice: 0,
                    actualPrice: 0,
                    stateMaps: []
                };
            }
        },
        orderChildrenIds: {
            type: Array,
            default: () => {
                return []
            }
        },
        payMoney: {
            type: Number,
            default: () => {
                return 0
            }
        },
        orderMainId: {
            type: String,
            default: () => {
                return ""
            }
        },
        routeData: {
            type: String,
            default: ''
        }
    },
    // 方法集合
    methods: {
        closePopup() {
            this.payShow = false
            this.$emit('payUpload')
        },
        //审核按钮
        handlerWalletClick(id) {
            //如果没有城市信息
            // if(){
            //     return this.$message.warning('没有城市信息,无法发起审核!')
            // }
            const map = {
                '19': 'walletBalance',
                '20': 'paymentOfGroupSpecialFunds',
                '21': 'balanceOfSpecialFunds'
            }

            if (map[id]) {
                this.$confirm('您确定发起审核吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    new OrderApi("order")[map[id]]({ orderMainId: this.orderMainId }).then(res => {
                        this.createLoading({ isBody: true, innerText: "发送中..." })
                        if (res.status === 200) {
                            this.$message({
                                type: 'success',
                                message: '发送成功!'
                            });
                            this.checkPayChange(3)
                            // 发送公众号消息通知
                            new ApplyApi("apply").firstSendApproval(this.orderMainId,'').then(res => {
                                if (!this.userInfor.officialAccount) {
                                    let userId = this.$store.state.userInfor.userId
                                    let url = process.env["VUE_APP_ACCOUNT_H5_SERVE"] + `?userId=${userId}`
                                    this.$refs.officialAccountVue.initClick(url)
                                }
                                this.closeLoading()
                            })
                        } else {
                            this.$message.error(res.statusText)
                            this.closeLoading()
                        }
                    })
                })
            }
        },
        updatePrice() {
            this.payShow = false
            this.$emit('payUpload')
        },
        walletFlag(obj) {
            let data = {
                auditingText: '',//按钮文字
                auditingFlag: false,//是否显示电话和短信验证
            }
            if (JSON.stringify(obj) === '{}') {
                return false
            } else {
                //如果审批为开启 直接显示电话号码和邮箱验证
                if (!obj.isApprovalEnabled) {
                    data.auditingFlag = true
                } else {
                    const map = {
                        0: obj.applyConfigText,
                        1: '审核中...',
                        //2:'',//直接显示电话号码和邮箱验证
                        3: '审批驳回',
                    }
                    if (map[obj.schedule]) {
                        data.auditingText = map[obj.schedule]
                    } else {
                        data.auditingFlag = true
                    }
                }
            }
            return data
        },
        confirmPay() {
            // 钱包支付
            if (this.checkPay === 3) {
                let obj = {
                    "bizId": this.ruleForm.bizId,
                    "code": this.ruleForm.code,
                    "orderChildrenIds": this.orderChildrenIds,
                    "payMoney": this.payMoney
                }
                this.createLoading({ isBody: true, innerText: "钱包支付中..." })
                new PayApi("pay").balanceWalletPay(obj).then(res => {
                    if (res.status === 200) {
                        this.$message.success("支付成功...")
                        this.payShow = false
                        this.$emit('payUpload')
                    } else {
                        this.$message.error(res.statusText)
                    }
                    this.closeLoading()
                })
            }
            // 微信支付
            if (this.checkPay === 2) {
                this.$refs.payCpmponent.handlerSelectPriceClick()
            }
            // 支付宝支付
            if (this.checkPay === 1) {
                this.$refs.payCpmponent.handlerSelectPriceClick()
            }
        },
        init() {
            this.payShow = true
            this.$nextTick(() => {
                this.checkPayChange(3)
            })
        },
        checkPayChange(e) {
            this.checkPay = Number(e)
            if (e == 3) {
                this.isLoading = true
                new PayApi("pay").paymentApprovalQuery({ orderMainId: this.orderMainId }).then(res => {
                    if (res.status === 200) {
                        this.walletObj = res.data
                        this.checkPay = 3
                        this.isLoading = false
                    } else {
                        this.$message.error(res.statusText)
                        this.isLoading = false
                    }
                })
            } else {
                this.checkPay = Number(e)
            }
        },
        verify() {
            let _data = new CountDown(60)
            _data.getCountDown();
            setInterval(() => {
                this.count = _data.currentSecond()
            }, 1000)
            //发送验证码
            new OrderApi("order").sendPayCode().then((result) => {
                if (result.status === 200 && result.data !== '') {
                    this.ruleForm.bizId = result.data
                    this.$message.success("发送成功,请留意手机短信,获取验证码！")
                }
            })
        }
    },
    // 计算属性 类似于 data 概念
    computed: {
        ...mapState(['userInfor'])
    },
    // 监控 data 中的数据变化
    watch: {},
    //过滤器
    filters: {},
    // 生命周期 - 创建之前
    beforeCreate() {
    },
    // 生命周期 - 创建完成（可以访问当前this 实例）
    created() {
    },
    // 生命周期 - 挂载之前
    beforeMount() {
    },
    // 生命周期 - 挂载完成（可以访问 DOM 元素）
    mounted() {
    },
    // 生命周期 - 更新之前
    beforeUpdate() {
    },
    // 生命周期 - 更新之后
    updated() {
    },
    // 生命周期 - 销毁之前
    beforeDestroy() {
    },
    // 生命周期 - 销毁完成
    destroyed() {
    },
    // 如果页面有 keep-alive 缓存功能,这个函数会触发
    //进入的时候触发
    activated() {
    },
    //离开的时候触发
    deactivated() {
    },
}
</script>
<style>
.customProduct {
    width: 25%;
}
</style>
<style scoped lang="scss">
.productTypeDialog /deep/ .el-dialog__header {
    display: none;
}

.Total-Price {
    display: flex;
    justify-content: space-between;
}

._p {
    width: 300px;
}

.lineBox {
    padding-left: 0.12rem;
    display: flex;
    align-items: center;
    margin-bottom: 0.1rem;

    .lineBoxP1 {
        width: 1rem;
    }
}

.productTypeDialog /deep/ .dialog-top {
    width: 100%;
    background: var(--navberColor);
    color: white;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    border-radius: 0.2rem 0.2rem 0 0;
    font-size: 14px;
}

.productTypeDialog /deep/ .el-dialog__body {
    padding: 0;

    .el-divider--horizontal {
        margin-top: -1px;
    }
}

.productTypeDialog /deep/ .el-checkbox {
    width: 0.7rem;
    line-height: 2;
}

.productTypeDialog /deep/ .product-checkBox {
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;

    .el-radio {
        width: 74px;

        .el-radio__label {
            padding: 0;
        }

        .el-radio__input {
            display: none;
        }
    }

    .alipay {
        display: inline-flex;

        .el-radio__label {
            >img {
                width: 120px;
            }

            &:hover {
                cursor: pointer;
            }
        }
    }

    .wechat {
        display: inline-flex;

        .el-radio__label {
            >img {
                width: 120px;
            }

            &:hover {
                cursor: pointer;
            }
        }
    }

    .wallet {
        display: inline-flex;
        margin-left: 5px;

        .el-radio__label {
            >img {
                margin-left: -8px;
                height: 26.66px;
                transform: scale(0.7);
            }

            &:hover {
                cursor: pointer;
            }
        }
    }
}

.amountDetails {
    margin-left: 10px;
    padding-bottom: 25px;
}

.opButton {
    padding-bottom: 11px;
    text-align: end;
    margin-right: 20px;
}

/deep/ .mobileVerification {
    .el-form-item {
        .el-form-item__label {
            text-align: left;
            margin-left: 10px;
        }
    }

    .macontent {
        position: relative;
        top: -14px;
        margin-bottom: 0px;

        .el-form-item__content {
            left: -21px;
            top: -6px;
        }
    }
}

.input-with-select {
    width: 100px;

    /deep/ .el-input__inner {
        border-radius: 0px;
        border-top-width: 0px;
        border-left-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        text-align: center;
    }
}

.verify {
    position: relative;
    top: 4px;
    color: #CB582E;
    &:hover {
        cursor: pointer;
        color: red;
    }
}
</style>
